// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uEJD","col":"styles_col__23C-n"};